import styled from 'styled-components';
import {
  LargeSectionHeader,
  PrimaryLink,
} from '../../../../../../stories/components/CommonStyleUtils/dwebCommon.styles';

export const Container = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 70px;
  margin: ${props => (props.margin ? props.margin : 0)};
`;
export const DiningCol = styled.div``;

export const DiningTitle = styled.p`
  font-size: 14px;
  font-weight: 700;
  color: #141823;
  margin-bottom: 12px;
`;
export const DiningList = styled.ul`
  display: grid;
  grid-template-columns: 1fr;
  gap: 8px;
  li {
    position: relative;
    font-size: 14px;
    color: #141823;
    line-height: 16px;
    padding-left: 12px;
    &::before {
      content: '';
      width: 4px;
      height: 4px;
      background-color: #141823;
      border-radius: 50%;
      position: absolute;
      left: 0;
      top: 6px;
    }
  }
`;

export const SingleRestaurentUI = styled.section(
  props => `
    width: 100%;
    margin: 0 auto 2rem;
    max-width:120rem;
    background-color: ${props.theme.colors.goWhite.base};
    border-radius: ${props.theme.misc.borderRadius.xxxlarge};
    padding-bottom:10px;
      `,
);

export const DiningHeader = styled(LargeSectionHeader)(
  props => `
      border-bottom: 0.1rem solid ${props.theme.colors.ash.dark};
      padding: ${props.theme.spacing.xlarge} ${props.theme.spacing.xxlarge};
      border-bottom-left-radius:0;
      border-bottom-right-radius:0;
    `,
);

export const SingleFoodWrapper = styled.div(
  props => `
    padding: ${props.theme.spacing.custom(24)};
  `,
);

export const ViewAllButton = styled(PrimaryLink)(
  props => `
      font-size: ${props.theme.font.custom(16)};
      font-weight:bold;
      padding:${props.theme.spacing.base} ${props.theme.spacing.xxlarge}; 
      `,
);

export const SummaryContainer = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 10px;
`;

export const SummaryItem = styled.div`
  font-size: 16px;
  padding-left: 5px;
`;

export const GreyDot = styled.span(
  props => `
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background-color: #4a4a4a;
  display: inline-block;
  flex-shrink: 0;
  margin-top: 3px;
  margin-right:5px
  `,
);
